import { queryOptions } from '@tanstack/react-query';
import { fieldHistoryApi } from './field-history.api';

export const fieldHistoryKeys = {
  all: ['ocr-template-field-history'] as const,
  forTemplate: (templateId: number) =>
    [...fieldHistoryKeys.all, templateId] as const
};

export const fieldHistoryQueries = {
  /**
   * Per-field extraction counts for one template.
   *
   * `enabled` is gated on the id only, so a listing surface that renders this
   * behind a popover can spread the options and add its own opened flag —
   * `useQuery({ ...fieldHistoryQueries.forTemplate(id), enabled: opened })`,
   * the same lazy fetch-on-open `TemplateFieldsInfo` uses. Nothing is fetched
   * until the reader actually asks.
   */
  forTemplate: (templateId: number) =>
    queryOptions({
      queryKey: fieldHistoryKeys.forTemplate(templateId),
      queryFn: () => fieldHistoryApi.forTemplate(templateId),
      enabled: templateId > 0
    })
};
